/**
 * Interpolates from start to end using the given threshold.
 *
 * @param start The start value.
 * @param end The end value.
 * @param threshold The interpolation value between the two numbers.
 * @returns Returns the interpolated value.
 * @example
 *
 * lerp(5, 10, 0.5)
 * // => 7.5
 *
 * lerp(-10, 10, 0.75)
 * // => 5
 */
export function lerp(start: number, end: number, threshold: number): number {
  return start + (end - start) * threshold;
}
